import { APIErrorResponse, isAPIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

import Identity from './identity';
import { headers, logPrefix, PROFILE_STORAGE_KEY_EXPIRED_TIME } from './constants';
import { SocialSignOnProviders } from './socialSignOnTypes';

/**
 * Removes a linked social identity from the user's identity. Currently only
 *
 * @param type
 *
 * @returns
 *
 * <details>
 * <summary>
 * On error (throws)
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/User+Registration/deleteIdentity
 * ```
 *
 * </details>
 */

export default async function unlinkSocialIdentity(
  grantType: SocialSignOnProviders
): Promise<boolean | APIErrorResponse> {
  const isLoggedIn = await Identity.isLoggedIn();
  if (!isLoggedIn) {
    throw new Error(`${logPrefix} Missing or invalid jwt`);
  }

  if (globalThis.google && grantType === 'google') {
    const userId: string =
      Identity?.userProfile?.identities?.find(i => i.type === 'Google')?.userName ?? '';
    try {
      globalThis.google.accounts.id.revoke(userId);
    } catch (e) {
      throw new Error(`[Arc Identity SDK]: Error revoking sign in with google user consent. ${e}`);
    }
  }
  return fetch(`${Identity.apiOrigin}/identity/public/v1/identity/${grantType}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${Identity.userIdentity.accessToken}`,
      ...headers
    }
  })
    .then(JSONResponseHandler)
    .then(json => {
      if (isAPIErrorResponse(json)) {
        throw json;
      } else {
        localStorage.removeItem(PROFILE_STORAGE_KEY_EXPIRED_TIME);

        return json;
      }
    });
}
